<div fxLayout="row" fxLayoutAlign="center center">
    <button kendoButton look="flat" icon="clip" (click)="showAttachments()"> 
        <strong *ngIf="docCount > 0">({{ docCount }})</strong>
    </button>
</div>


<div kendoDialogContainer #attachmentsDialog></div>